import React from "react";
import { Box, Typography, Container, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useRbac } from "../../hooks/RbacContext";

const PageNotFound = () => {
  const navigate = useNavigate();
  const { permissions } = useRbac();
  return (
    <Container>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          textAlign: "center",
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 60, color: "error.main", mb: 2 }} />
        <Typography variant="h4" component="h1" gutterBottom>
          404 - Page Not Found
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          The page you're looking for doesn't exist or has been moved.
        </Typography>
        {permissions?.globalRole?.role_id && permissions?.globalRole?.role_id === 13 ? (
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/timesheet")}
            sx={{ mt: 2 }}
          >
            Go to Timesheet
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/projects")}
            sx={{ mt: 2 }}
          >
            Go to Projects
          </Button>
        )}
      </Box>
    </Container>
  );
};

export default PageNotFound;
